module.exports = __webpack_public_path__ + "img/bg-zhengfaing.a4ecccde.png";